import { CanActivateFn, UrlTree, CanActivateChildFn } from '@angular/router';
import { getCookie } from '../utils/getCookies';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

export const companyGuard: CanActivateFn = (route, state) => {
  const hasToken = !!getCookie('access_token');

  // if we have a token, we return true
  if (hasToken) return true;
  
  // if we are not in production, we return true, we can see the app without being logged in
  if (!environment.production) return true;

  const router = inject(Router);
  return router.createUrlTree(['/company/login']);
};

export const companyChildGuard: CanActivateChildFn = (route, state) => {
  const hasToken = !!getCookie('access_token');

  // if we have a token, we return true
  if (hasToken) return true;

  // if we are not in production, we return true, we can see the app without being logged in
  if (!environment.production) return true;

  // if we don't have a token, we redirect to the login page
  const router = inject(Router);
  return router.createUrlTree(['/company/login']);
};